import '../../../common/dashboard/filters/single_filters/modal_filter_view.js.coffee';# Added by Script 
import '../../../common/dashboard/filters/single_filters/multiple_values_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.SingleFilters'

class CustomerVisualMode.Filters.SingleFilters.HierarchicalTagsFilterView extends Common.Sessions.Filters.SingleFilters.ModalFilterView
  template: JST['backbone/templates/customer_visual_mode/filters/single_filters/hierarchical_tags_filter']

  initialize: ({values, placeholder, title, selectedOptions, editable, acceptButtonText}) ->
    super({editable, values, placeholder, title, selectedOptions, acceptButtonText})
    @currentTags = selectedOptions
    @formattedNodes = @_formatNodes(@values)

  events:
    _.extend({}, Common.Sessions.Filters.SingleFilters.ModalFilterView.prototype.events,
      'keyup #search-tag': '_onEnterText'
    )

  render: ->
    super()
    @$el.addClass('hierarchical-tags-filter')
    @$el.find('.modal-body').html @template
      translations:
        placeholder: @placeholder
    @treeContainer = @$el.find('#tree-container')
    @_renderTree()
    @_onJsTreeChange()
    @

  getSelectedValues: =>
    selectedValues = @treeContainer.jstree(true).get_selected(true)
    selectedValues.filter((node) -> node.children.length == 0).map((node) -> node.id)

  _onEnterText: ->
    clearTimeout(@searchTimer)
    @searchTimer = setTimeout =>
      @_search()
    , 1000

  _search: ->
    keyword = @$el.find('#search-tag').val()
    @treeContainer.jstree(true).search(keyword)

  _renderTree: ->
    @treeContainer.on('search.jstree', (e, data) =>
      firstResult = $(@).find('.jstree-search:eq(0)').get(0)
      firstResult.scrollIntoView() if firstResult
    ).on('changed.jstree', @_onJsTreeChange).jstree(
      plugins: ['checkbox', 'search']
      core:
        themes:
          icons: false
          dots: false
        data: @formattedNodes
    )

  _onJsTreeChange: =>
    valuesAreSelected = @getSelectedValues().length != 0
    @_setDisableAcceptButton({disabled: !valuesAreSelected})

  _formatNodes: (nodes) ->
    _.map(_.sortBy(nodes || [], (node) -> node.name), (node) =>
      id: node.code
      text: @_tagDisplayText node
      children: _.union(@_formatNodes(node.children))
      state:
        selected: _.contains(@currentTags, node.code)
    )

  _tagDisplayText: (tag) ->
    if tag.active then tag.description else "#{tag.description} #{@_deactivatedLabel()}"

  _deactivatedLabel: ->
    "<span class='hierarchical-tag-deactivated'>(#{@_deactivatedText()})</span>"

  _deactivatedText: ->
    I18n.t 'common.session.filters.hierarchical_tags.modal.deactivated'
